import { BasePageResponse } from './models'
import { FetchArgs, FetchBaseQueryError, QueryReturnValue } from '@reduxjs/toolkit/query/react'

export type MaybePromise<T> = T | PromiseLike<T>

export const paginate = async <T>(
  fetchArgs: FetchArgs,
  fetchWithBQ: (arg: string | FetchArgs) => MaybePromise<QueryReturnValue<unknown, FetchBaseQueryError, object>>,
) => {
  let currPage = 0
  const entities: T[] = []
  while (true) {
    const page = (await fetchWithBQ({
      ...fetchArgs,
      params: { ...fetchArgs.params, page: currPage, size: 500 },
    })) as QueryReturnValue<BasePageResponse<T[]>, FetchBaseQueryError>
    const { error, data: pageData } = page
    if (error) {
      return { error }
    }
    entities.push(...pageData.data)
    if (pageData.page.totalPages <= pageData.page.number + 1) {
      break
    }
    currPage++
  }
  return { data: { data: entities } }
}

export const hasTenMinutesPassed = (isoDate?: string): boolean => {
  if (!isoDate) {
    return false
  }
  try {
    const timeInMs = new Date(isoDate).getTime()
    const nowInMs = Date.now()
    const tenMinutesInMs = 10 * 60 * 1000

    return nowInMs - timeInMs >= tenMinutesInMs
  } catch (e) {
    console.error(e)
  }
  return false
}

export const removeAiAgentInconsistency = (message: string): string => {
  return message.replaceAll('`', '').replaceAll('json', '').trim()
}
